import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type ToastType = 'success' | 'error';

export type Toast = {
  message: string;
  type: ToastType;
  id: number;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastSubject = new Subject<Toast>();
  readonly toast$ = this.toastSubject.asObservable();
  private nextId = 0;

  show(message: string, type: ToastType = 'success'): void {
    this.toastSubject.next({ message, type, id: this.nextId++ });
  }
}
